import React, { useEffect, useState } from 'react';

import Firebase from '../services/Firebase';
import Log from '../services/Log';

export const AuthContext = React.createContext();

export const Auth = ({ children }) => {
  // Data object is { loading: bool, user: object|null }
  const [data, setData] = useState({ loading: true, user: null });

  useEffect(() => {
    const unsubscribe = Firebase.auth().onAuthStateChanged((user) => {
      Log.message(`Auth state changed, setting user to ${user?.uid ?? 'null'}`);
      setData({ loading: false, user });
    });
    return () => unsubscribe();
  }, []);
  return (
    <AuthContext.Provider value={{data}}>
      {children}
    </AuthContext.Provider>
  );
};
